<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
        <div id="firebaseui-auth"></div>
    </v-layout>
  </v-container>
</template>
<script>
/*global firebase*/
/*global firebaseui*/
export default {
  mounted() {
    var uiConfig = {
      callbacks: {
        signInSuccessWithAuthResult: function(authResult, redirectUrl) {
          // User successfully signed in.
          // Return type determines whether we continue the redirect automatically
          // or whether we leave that to developer to handle.
          console.log("signed in!! ");
          console.log(authResult);
          console.log(redirectUrl);
          return false;
        }
      },
      credentialHelper: firebaseui.auth.CredentialHelper.NONE,
      signInOptions: [
        firebase.auth.EmailAuthProvider.PROVIDER_ID
      ]
    };

    this.$fire_ui.start("#firebaseui-auth", uiConfig);
  }
};
</script>
